// @flow
// eslint-disable-next-line import/prefer-default-export
export function getSubscriptionIdFromErrorMessage(errorMessage: string): string {
  const errorMessageSplitted = errorMessage.split(':');
  if (!errorMessageSplitted[1]) {
    return '';
  }

  return errorMessageSplitted[1].trim();
}



// WEBPACK FOOTER //
// ./app/Notifications/utils.js